"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Jsona_1 = require("./Jsona");
exports.Jsona = Jsona_1["default"];
var ModelsSerializer_1 = require("./builders/ModelsSerializer");
exports.ModelsSerializer = ModelsSerializer_1["default"];
var JsonDeserializer_1 = require("./builders/JsonDeserializer");
exports.JsonDeserializer = JsonDeserializer_1["default"];
var simplePropertyMappers_1 = require("./simplePropertyMappers");
exports.ModelPropertiesMapper = simplePropertyMappers_1.ModelPropertiesMapper;
exports.JsonPropertiesMapper = simplePropertyMappers_1.JsonPropertiesMapper;
var switchCasePropertyMappers_1 = require("./switchCasePropertyMappers");
exports.SwitchCaseModelMapper = switchCasePropertyMappers_1.SwitchCaseModelMapper;
exports.SwitchCaseJsonMapper = switchCasePropertyMappers_1.SwitchCaseJsonMapper;
exports["default"] = Jsona_1["default"];